import { useLayoutEffect, useState } from 'react';
import { getResponsiveChatFrame } from '../lib/panelLayout';

export function useAssistantViewportFrame() {
  const [frame, setFrame] = useState(getResponsiveChatFrame);
  useLayoutEffect(() => {
    const update = () => setFrame(getResponsiveChatFrame());
    const viewport = window.visualViewport;
    window.addEventListener('resize', update);
    viewport?.addEventListener('resize', update);
    viewport?.addEventListener('scroll', update);
    update();
    return () => {
      window.removeEventListener('resize', update);
      viewport?.removeEventListener('resize', update);
      viewport?.removeEventListener('scroll', update);
    };
  }, []);
  return frame;
}
